<div
  class="menu-group-label-container"
  [attr.data-size]="size"
  [attr.data-variant]="variant"
  [attr.data-disabled]="disabled"
  [attr.data-indented]="isIndented"
>
  <div
    class="menu-group-label"
    [attr.role]="'group'"
    [attr.aria-label]="displayText"
  >
    <span class="group-label-text">{{ displayText }}</span>
  </div>
</div>
